var _regeneratorRuntime = require("/var/lib/jenkins/jobs/LiDARnetics - Client - PROD_REDUX deploy/workspace/lidarnetics_client_prod_redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/lib/jenkins/jobs/LiDARnetics - Client - PROD_REDUX deploy/workspace/lidarnetics_client_prod_redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var readHeader = require('./utils/readHeader');

var _require = require('./utils/helper'),
    bufferFromLocalFile = _require.bufferFromLocalFile,
    bufferFlipper = _require.bufferFlipper,
    bufferFromUrl = _require.bufferFromUrl,
    fileObjToBuffer = _require.fileObjToBuffer;

var assertOptions = function assertOptions(options) {
  if (!options.input) {
    throw new Error('las-header: Input required');
  }
};

var readLocalFile = function readLocalFile() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  assertOptions(options);
  var input = options.input;
  var buffer = bufferFromLocalFile({
    input: input
  });
  return parseHeaders({
    buffer: buffer
  });
};

var readUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var options,
        input,
        _yield$bufferFromUrl,
        buffer,
        arrayBuffer,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            assertOptions(options);
            input = options.input;
            _context.next = 5;
            return bufferFromUrl({
              input: input
            });

          case 5:
            _yield$bufferFromUrl = _context.sent;
            buffer = _yield$bufferFromUrl.buffer;
            arrayBuffer = _yield$bufferFromUrl.arrayBuffer;
            return _context.abrupt("return", parseHeaders({
              buffer: buffer,
              arrayBuffer: arrayBuffer
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function readUrl() {
    return _ref.apply(this, arguments);
  };
}();

var readFileObject = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var options,
        input,
        _yield$fileObjToBuffe,
        buffer,
        arrayBuffer,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            assertOptions(options);
            input = options.input;
            _context2.next = 5;
            return fileObjToBuffer({
              input: input
            });

          case 5:
            _yield$fileObjToBuffe = _context2.sent;
            buffer = _yield$fileObjToBuffe.buffer;
            arrayBuffer = _yield$fileObjToBuffe.arrayBuffer;
            return _context2.abrupt("return", parseHeaders({
              buffer: buffer,
              arrayBuffer: arrayBuffer
            }));

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function readFileObject() {
    return _ref2.apply(this, arguments);
  };
}();

var parseHeaders = function parseHeaders() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var inputArrayBuffer = options.arrayBuffer ? options.arrayBuffer : bufferFlipper(options.buffer);
  var inputDataView = new DataView(inputArrayBuffer);
  var header = new readHeader({
    inpuBuffer: options.buffer,
    inputArrayBuffer: inputArrayBuffer,
    inputDataView: inputDataView
  });
  return header.getValues();
};

module.exports = {
  readLocalFile: readLocalFile,
  readUrl: readUrl,
  readFileObject: readFileObject
};